import React, { ReactNode } from 'react';
import styles from './AuthForm.module.scss';

type AuthFormProps = {
    children: ReactNode;
};

export default function AuthForm(props: AuthFormProps) {
    const { children } = props;
    return <div className={styles.form}>{children}</div>;
}
